import { Text } from "@/elements"

export const ActivityCountLeftComponent: React.FC<{
  count: number
}> = ({ count }) => {
  return (
    <div className="bg-primary-2 flex size-[40px] items-center justify-center rounded-full">
      <Text>{count}</Text>
    </div>
  )
}
